var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGlOncologicoFilled(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 4C9.38 4 4 9.38 4 16C4 22.62 9.38 28 16 28C22.62 28 28 22.62 28 16C28 9.38 22.62 4 16 4ZM19.15 24.03C19.15 24.03 17.65 22.32 16 20.26C14.35 22.32 12.84 24.04 12.84 24.04L10.98 21.27C10.98 21.27 12.38 19.69 13.98 17.64C12.75 15.96 11.79 14.42 11.79 13.72C11.79 11.17 13.59 8 15.96 8C18.33 8 20.2 11.19 20.2 13.73C20.2 14.42 19.24 15.96 18.02 17.64C19.62 19.68 21.02 21.26 21.02 21.26L19.16 24.03H19.15ZM14.11 11.96C14.6 12.89 15.27 13.91 16 14.95C16.73 13.92 17.39 12.89 17.88 11.96C17.26 11.49 16.64 11.33 16.08 11.33C14.98 11.33 14.14 11.94 14.11 11.96Z",
    fill: "#141938"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGlOncologicoFilled);
export default __webpack_public_path__ + "static/media/gl_oncologico_filled.ce13c749b7e1a1a725722eee18a5517d.svg";
export { ForwardRef as ReactComponent };